<!-- (textChange)="receiveText($event)" -->

<mds-search-bar
  (enterEvent)="onEnter($event)"
  (showDropdown)="isDropdown($event)"
  [isFrom]="'globalsearch'"
  [placeholder]="'Search something...'"
  [showContent]="showContent"
  [formControl]="searchControl"
  [theme]="'dark'"
>
  <section #searchResultSection>
    <section class="search-droplist">
      <div (click)="closeMenu()" class="search-droplist__backdrop"></div>
      <article class="search-droplist__container">
        <mds-button-toggle
          [checkedButton]="selectedTab"
          [multiple]="false"
          [options]="tabs"
          (change)="onSwitchTabView($event)"
        ></mds-button-toggle>
        @if (selectedTab === SearchTypeEnum.GLOBAL) {
          <div class="search-droplist__list">
            <div #tabContainer [ngClass]="{ 'has-scroller': tabHasScroll }" class="tabs-container">
              @if (isLargeScreen) {
                <mds-tab (activeTabChange)="getActiveTab($event)" [tabs]="searchSchema.schema"></mds-tab>
              }
            </div>

            @if (isLargeScreen) {
              <div class="search-droplist__content">
                @if ((!this.firstSearchFlag &&
                  this.inputText?.length >= 1 &&
                  this.productList.length > 0 &&
                  !this.loading) ||
                scrollingStarted) {
                  <div
                    [ngStyle]="{
                'min-width': currentTab?.formSchema.length > 0 ? '' : '100%'
              }"
                    class="search-results"
                  >
                    <section (scroll)="onScroll($event)" class="search-results__content">
                      <div>
                        @for (data of productList; track data) {
                          <button
                            class="object-card-btn"
                            (click)="openProduct(data)"
                            aria-label="opt.title || opt.name"
                            tabindex="0"
                          >
                            <mds-object-card
                              (menuClick)="openMenuItem($event)"
                              [data]="data"
                              [showText]="false"
                              [searchKey]="searchControl.value"
                            ></mds-object-card>
                          </button>
                        }
                        @if (scrollingStarted) {
                          <div class="loading-records">
                            <mds-loader loadingText="Loading more records, Please wait..."></mds-loader>
                          </div>
                        }
                      </div>
                    </section>
                  </div>
                }
                @if (this.recentSearchList.length > 0 && !this.loading && this.inputText?.length < 1) {
                  <div
                    [ngStyle]="{
                'min-width': currentTab?.formSchema.length > 0 ? '' : '100%'
              }"
                    class="search-results"
                  >
                    <section class="search-results__header">
                      <h4>Recently searched</h4>
                    </section>
                    <section class="search-results__content">
                      @for (data of recentSearchList; track data) {
                        <button
                          (click)="openProduct(data)"
                          class="object-card-btn"
                          aria-label="opt.title || opt.name"
                          tabindex="0"
                        >
                          <mds-object-card (menuClick)="openMenuItem($event)" [data]="data"
                                           [searchKey]="searchControl.value"></mds-object-card>
                        </button>
                      }
                    </section>
                  </div>
                }
                @if (getPlaceHolder() !== '' && !scrollingStarted && !this.productList?.length) {
                  <div
                    [ngStyle]="{
                'min-width': currentTab?.formSchema.length > 0 ? '' : '100%'
              }"
                    class="search-droplist__placeholder"
                  >
                    <mds-search-placeholder
                      (filterValueChanged)="filtersUpdate($event)"
                      [placeholder]="getPlaceHolder()"
                      class="search-droplist__placeholder-content"
                    ></mds-search-placeholder>
                  </div>
                }
                @if (currentTab?.formSchema.length > 0) {
                  <div class="filter-width">
                    <mds-search-filter
                      (filterValueChanged)="filterValueChanged($event)"
                      [data]="currentTab"
                    ></mds-search-filter>
                  </div>
                }
              </div>
            }
            @if (!isLargeScreen) {
              <section class="search-results-mobile-view" style="height: 514px">
                <!-- this block shows small screen, small screen , i.e >= 960 -->
                <div class="result-text">
                  <span>RESULT</span>
                  <div class="filters active-filter">
                    <div class="select-search-type">
                      <button [matMenuTriggerFor]="menu" aria-label="filter on search" class="filter-menu" role="group">
                        <div class="menu-label">
                          <span class="filter-label">{{ currentTab?.label }}</span>
                        </div>
                        <mds-icon [height]="14" [key]="icons.ARROW_DOWN" [width]="14" class="icon-position"></mds-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        @for (type of searchSchema.schema; track type) {
                          <button
                            (click)="updateFilter(type)"
                            [attr.aria-label]="type.label"
                            [ngClass]="{
                        'active-selector': currentTab?.label == type.label
                      }"
                            mat-menu-item
                            role="menuitem"
                          >
                            @if (currentTab?.label == type.label) {
                              <mds-icon
                                [height]="18"
                                [key]="icons.CHECKED"
                                [pathColors]="['#000000']"
                                [width]="18"
                              ></mds-icon>
                            }
                            {{ type.label }}
                          </button>
                        }
                      </mat-menu>
                    </div>
                    <span class="divider"></span>
                    <span style="position: relative">
                    <mds-icon [height]="24" [key]="icons.FILTER" [width]="24"></mds-icon>
                  </span>
                    <span class="divider"></span>
                    <span>
                    <button (click)="toggleSections()" aria-label="toggle filter">
                      <mds-icon [height]="24" [key]="icons.MENU_TAG" [width]="24"></mds-icon>
                    </button>
                  </span>
                  </div>
                </div>
                @if (showResultSection) {
                  <article style="overflow: auto; height: 480px">
                    <!-- Result section -->
                    <div class="search-result-wrapper">
                      @for (data of productList; track data) {
                        <div>
                          <button
                            (click)="openProduct(data)"
                            aria-label="opt.title || opt.name"
                            style="width: 100%; padding: unset; border: none"
                            tabindex="0"
                          >
                            <mds-object-card (menuClick)="openMenuItem($event)" [data]="data"
                                             [searchKey]="searchControl.value"></mds-object-card>
                          </button>
                        </div>
                      }
                    </div>
                  </article>
                } @else {
                  <!-- Filter section -->
                  <mds-search-filter
                    (filterValueChanged)="filterValueChanged($event)"
                    [data]="currentTab"
                  ></mds-search-filter>
                }
              </section>
            }
          </div>
        } @else {
          <app-material-catalog (closeMenu)="closeMenu()"></app-material-catalog>
        }
      </article>
    </section>

  </section>
</mds-search-bar>
